import { useState } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';
import RatingStars from '@/components/feature/RatingStars';
import { useSEO } from '@/components/base/useSEO';

const teamAvatarUrls: Record<string, string> = {
  'team-ceo': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20male%20founder%20in%20creative%20industry%2C%20warm%20studio%20lighting%2C%20confident%20expression%2C%20modern%20casual%20attire%2C%20clean%20white%20background&width=160&height=160&seq=team-ceo&orientation=squarish',
  'team-content': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20female%20editor%20in%20publishing%20industry%2C%20warm%20studio%20lighting%2C%20friendly%20expression%2C%20modern%20professional%20attire%2C%20clean%20background&width=160&height=160&seq=team-content&orientation=squarish',
  'team-tech': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20male%20engineer%20with%20glasses%2C%20tech%20office%20lighting%2C%20thoughtful%20expression%2C%20casual%20tech%20attire%2C%20clean%20background&width=160&height=160&seq=team-tech&orientation=squarish',
  'team-ops': 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20female%20operations%20manager%2C%20bright%20office%20lighting%2C%20energetic%20expression%2C%20modern%20professional%20attire%2C%20clean%20background&width=160&height=160&seq=team-ops&orientation=squarish',
};

const teamMembers = [
  {
    name: '李明远',
    role: '创始人 & CEO',
    desc: '资深漫画爱好者，拥有10年互联网产品经验，致力于打造最优质的内容平台。',
    seq: 'team-ceo',
  },
  {
    name: '王晓婷',
    role: '内容总监',
    desc: '前知名漫画平台主编，深耕漫画领域8年，对内容品质有着极致的追求。',
    seq: 'team-content',
  },
  {
    name: '张浩然',
    role: '技术负责人',
    desc: '全栈工程师，曾就职于多家互联网大厂，负责平台技术架构与创新。',
    seq: 'team-tech',
  },
  {
    name: '陈思雨',
    role: '运营总监',
    desc: '社区运营专家，擅长用户增长与社群建设，打造了超过500万用户的活跃社区。',
    seq: 'team-ops',
  },
];

const testimonials = [
  {
    name: '漫画迷小王',
    role: '资深用户 · 3年',
    content: '黄漫天堂是我每天必刷的平台，分类清晰、更新及时，最重要的是作品质量真的很高。在这里发现了很多宝藏作品，推荐给所有漫画爱好者！',
    rating: 9.8,
  },
  {
    name: '创作者阿杰',
    role: '签约作者',
    content: '作为一名漫画创作者，黄漫天堂给了我一个非常好的展示平台。平台的流量支持和读者互动让我更有动力创作，收入也比之前翻了好几倍。',
    rating: 9.5,
  },
  {
    name: '读者小美',
    role: '忠实粉丝 · 2年',
    content: '界面设计简洁大方，阅读体验非常流畅。特别喜欢分类浏览功能，每次都能根据心情找到适合的内容。客服响应也很快，有问题当天就能解决。',
    rating: 9.6,
  },
  {
    name: '资深漫评人老刘',
    role: '行业观察者',
    content: '黄漫天堂在内容筛选和推荐算法方面做得非常出色。相比其他平台，这里的作品品质控制更加严格，用户体验和内容质量都处于行业领先水平。',
    rating: 9.3,
  },
  {
    name: '大学生小陈',
    role: '新用户 · 半年',
    content: '朋友推荐过来的，一试就停不下来了。新作速递功能太棒了，总能第一时间发现最新更新的内容。推荐算法也很准，推送的都是我喜欢的类型。',
    rating: 9.4,
  },
  {
    name: '上班族阿琳',
    role: '活跃用户 · 1年',
    content: '下班后最喜欢的放松方式就是刷黄漫天堂。作品种类丰富，画风精美，而且很多连载作品更新非常稳定。已经推荐给好几个同事了！',
    rating: 9.7,
  },
];

const milestones = [
  { year: '2023年3月', event: '黄漫天堂正式上线，首批收录500+精选作品' },
  { year: '2023年8月', event: '注册用户突破100万，上线分类浏览与智能推荐功能' },
  { year: '2024年1月', event: '创作者专区上线，签约首批50位优质漫画创作者' },
  { year: '2024年6月', event: '用户突破300万，日活跃用户超过50万' },
  { year: '2024年12月', event: '荣获"年度最佳内容平台"称号，作品库突破1000部' },
  { year: '2025年5月', event: '月活跃用户突破500万，成为行业领先的漫画导航平台' },
  { year: '2026年1月', event: '全面升级推荐系统，接入AI智能内容筛选，用户体验大幅提升' },
];

const faqs = [
  {
    q: '黄漫天堂是什么平台？',
    a: '黄漫天堂是专为漫画爱好者打造的一站式内容导航与推荐平台。我们汇聚海量优质漫画资源，提供分类浏览、热门排行、新作速递等功能，帮助用户快速找到心仪的漫画内容。',
  },
  {
    q: '黄漫天堂的内容是免费的吗？',
    a: '黄漫天堂作为内容导航平台，提供免费的浏览和发现服务。部分作品可能引导至创作者官方渠道获取完整内容。我们会持续优化体验，让用户享受最优质的漫画发现之旅。',
  },
  {
    q: '如何在黄漫天堂找到我喜欢的作品？',
    a: '你可以通过首页的分类浏览功能，按校园青春、职场OL、奇幻异世界等分类浏览；也可以查看热门排行发现最受欢迎的作品；新作速递版块则会第一时间展示最新更新的内容。',
  },
  {
    q: '我是漫画创作者，如何加入黄漫天堂？',
    a: '欢迎优秀的漫画创作者加入我们！你可以通过首页"创作者专区"中的"成为创作者"按钮提交申请，我们的内容团队会在3个工作日内审核并与你联系。',
  },
  {
    q: '黄漫天堂的作品更新频率如何？',
    a: '我们与众多优秀创作者保持紧密合作，平台上的热门作品通常保持每周更新的频率。新作速递版块实时同步最新更新，确保你不会错过任何精彩内容。',
  },
  {
    q: '遇到问题如何联系客服？',
    a: '你可以通过以下方式联系我们：发送邮件至 contact@huangman.tt，或在网站底部找到我们的社交媒体账号进行联系。我们的客服团队工作时间为周一至周五 9:00-18:00，通常会在24小时内回复。',
  },
];

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const jsonLd = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  });

  useSEO({
    title: '关于我们 - 品牌介绍 · 用户口碑 · 联系方式 - 黄漫天堂',
    description: '黄漫天堂创立于2023年，是专为漫画爱好者打造的一站式内容导航与推荐平台。了解我们的品牌故事、核心团队、发展历程与用户口碑。',
    keywords: '黄漫天堂,关于我们,品牌介绍,用户口碑,联系方式,漫画平台',
    canonical: 'https://huangman.tt/about',
    jsonLd,
  });

  return (
    <main className="min-h-screen pt-16">
      <div className="bg-background-100/70 border-b border-background-200/70">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]} />
        </div>
      </div>

      <section className="py-14 md:py-20 px-4 md:px-6" id="intro">
        <div className="max-w-[900px] mx-auto text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 font-heading mb-5">
            关于黄漫天堂
          </h1>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
            黄漫天堂创立于2023年，是专为漫画爱好者打造的一站式内容导航与推荐平台。我们从最初的500部精选作品起步，发展至今已收录超过1200部优质漫画内容，涵盖9大分类，拥有超过50位签约创作者，服务超过500万月活跃用户。我们始终坚持以用户为中心，不断优化推荐算法和使用体验，致力于成为漫画爱好者最信赖的内容发现平台。
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70" id="team">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
            核心团队
          </h2>
          <p className="text-foreground-500 text-sm text-center mb-10 max-w-xl mx-auto">
            一群热爱漫画的伙伴，用心打造最好的漫画发现平台
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {teamMembers.map((member) => (
              <div key={member.name} className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-20 h-20 rounded-full overflow-hidden bg-background-100 mx-auto mb-4">
                  <img
                    src={teamAvatarUrls[member.seq] || ''}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="font-semibold text-foreground-900 font-heading">{member.name}</h3>
                <p className="text-xs text-primary-500 font-medium mt-1">{member.role}</p>
                <p className="text-xs text-foreground-500 mt-2 leading-relaxed">{member.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 px-4 md:px-6" id="milestones">
        <div className="max-w-[900px] mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
            发展历程
          </h2>
          <p className="text-foreground-500 text-sm text-center mb-10">
            从初创到领先，每一步都离不开用户的支持
          </p>
          <div className="space-y-0">
            {milestones.map((milestone, i) => (
              <div key={i} className="flex gap-4 pb-8 relative">
                {i < milestones.length - 1 && (
                  <div className="absolute left-[15px] top-10 bottom-0 w-0.5 bg-background-200"></div>
                )}
                <div className="shrink-0 w-8 h-8 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  {i + 1}
                </div>
                <div className="pt-0.5">
                  <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                    {milestone.year}
                  </span>
                  <p className="text-sm text-foreground-700 mt-2">{milestone.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70" id="reputation">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
            用户口碑
          </h2>
          <p className="text-foreground-500 text-sm text-center mb-10">
            来自真实用户的评价，是我们前进的最大动力
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonials.map((item) => (
              <div key={item.name} className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                <div className="mb-3">
                  <RatingStars rating={item.rating} size="sm" />
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "{item.content}"
                </p>
                <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                  <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-600 text-xs font-bold">
                    {item.name[0]}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">{item.name}</p>
                    <p className="text-[10px] text-foreground-500">{item.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 px-4 md:px-6" id="faq">
        <div className="max-w-[800px] mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm text-center mb-10">
            快速了解黄漫天堂的常见问题与解答
          </p>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="rounded-xl border border-background-200/70 overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left bg-background-50 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                  <i className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 text-lg ${openFaq === i ? 'rotate-180' : ''}`}></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openFaq === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70" id="contact">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm mb-8">
            有任何问题或建议？我们随时倾听你的声音
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h4 className="font-medium text-foreground-800 text-sm font-heading">电子邮箱</h4>
              <a href="mailto:contact@huangman.tt" className="text-xs text-primary-500 hover:text-primary-600 transition-colors duration-200">
                contact@huangman.tt
              </a>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <h4 className="font-medium text-foreground-800 text-sm font-heading">微信公众号</h4>
              <p className="text-xs text-foreground-500">黄漫天堂官方</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mx-auto mb-3">
                <i className="ri-time-line text-lg"></i>
              </div>
              <h4 className="font-medium text-foreground-800 text-sm font-heading">工作时间</h4>
              <p className="text-xs text-foreground-500">周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}